module.exports = __webpack_public_path__ + "static/img/btn_add@3x.d41dea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/btn_add@3x.png
// module id = Uusy
// module chunks = 10